import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import { EstatusAdministrar } from '../../../models/tarea/tarea.module';
import { TareasService } from '../../../services/tareas.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-estatus',
  templateUrl: './estatus.component.html',
  styleUrls: ['./estatus.component.css']
})
export class EstatusComponent implements OnInit {
  token;
  estatus: any;
  info: EstatusAdministrar;
  del_info: EstatusAdministrar;
  edit_info: EstatusAdministrar;
  @Output() otrafuncion = new EventEmitter<any>();

  constructor(private _tareasService: TareasService, private _userService: UserService) {
    let token = this._userService.getToken();
    this.token = token;
    this.VerEstatus();
    this.otrafuncion = new EventEmitter();

  }

  ngOnInit(): void {
  }
  VerEstatus() {
    this._tareasService.VerEstatus(this.token).subscribe(
      response => {
        this.estatus = response;
      },
      error => {
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );
  }
  del_estatus(id_estatus) {
    Swal.fire({
      title: '¿Eliminar el estatus?',
      text: "Desea eliminar el estatus",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this.del_info = new EstatusAdministrar(id_estatus, "");
        this._tareasService.DelEstatus(this.del_info, this.token).subscribe(
          response => {
            this.otrafuncion.emit();
            this.VerEstatus();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );

      }
    });
  }
  edit_estatus(estatus, id_estatus) {
    (async () => {
      const { value: email } = await Swal.fire({
        title: 'Editar Estatus',
        input: 'text',
        inputValue: estatus,
        inputPlaceholder: 'Ingresa el nombre del estatus'
      })
      if (email) {
        this.del_info = new EstatusAdministrar(id_estatus, email);
        //console.log(this.del_info);
        //Swal.fire(`Entered email: ${email}`)
        this._tareasService.EditEstatus(this.del_info, this.token).subscribe(
          response => {
            //console.log(response);
            this.VerEstatus();
            this.otrafuncion.emit();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );
      }
    })();
  }
  agregar_estatus() {
    (async () => {
      const { value: email } = await Swal.fire({
        title: 'Nombre del Estatus',
        input: 'text',
        inputPlaceholder: 'Ingresa el nombre del estatus'
      })
      if (email) {
        this.del_info = new EstatusAdministrar(0, email);
        this._tareasService.AddEstatus(this.del_info, this.token).subscribe(
          response => {
            this.VerEstatus();
            this.otrafuncion.emit();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          },
          error => {
            console.log(error);
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        );
        //Swal.fire(`Entered email: ${email}`)
      }
    })();
  }
}
